import MuiFormControlLabel from '@mui/material/FormControlLabel';

import { styled } from 'helpers';

import { FormControlLabelProps } from './';

export const FormControlLabel = styled(MuiFormControlLabel)<FormControlLabelProps>`
  color: ${({ theme }) => theme.palette.blueGrey['A600']};

  & .MuiFormControlLabel-label.Mui-disabled {
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
  }

  &.MuiFormControlLabel-root {
    margin-left: 0;
    margin-right: 0;
  }
`;

export default FormControlLabel;
